/**
 * 账号设置
 *
 **/

import React from 'react';
import { Button, Form, message, Switch, Spin, Collapse, Input } from 'antd';
import { fetchLoginedUser } from "../../redux/actions/user";
import { findThirdAuth, updateSwitchOpert, findMsgTemplateCheck } from "../../services/signature";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import QRCode from "../../components/qr-code/QRCode";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity } from "../../services/global";
import { mobile_url_domin } from "../../utils/config";

const ASBody = styled.div`
    min-height: 500px;
`;
const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    const loginedUser = state.loginedUser;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchLoginedUser: bindActionCreators(fetchLoginedUser, dispatch),
});


class WxAuthorization extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        this.state = {
            authData: null,
            visible: false,
            formLoading: true,
            validity: false,

        }


    }

    componentDidMount() {
        this.fetchThirdAuth();
        isValidity('SUBACCOUNT', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }
    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    handleModalVisible = (flag) => {
        this.setState({ visible: flag });
    }
    fetchThirdAuth = () => {
        const { loginedUser } = this.props;
        this.changeFormLoading(true)
        findThirdAuth({ hostUserId: loginedUser.data.id, redirectUrl: encodeURI(`${window.location.origin}/authcodereport?hostUserId=${loginedUser.data.id}`) }).then(res => {
            if (res.code === 200) {
                this.setState({
                    authData: res.data,
                    msgSwitch: res.data.msgSwitchState == 1 ? true : false,
                    loginSwitch: res.data.loginAuthSwitchState == 1 ? true : false
                })
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            this.changeFormLoading(false)
        });
    }
    handleSwitchOpert = (openState, switchType) => {
        const { loginedUser } = this.props;
        updateSwitchOpert({ hostUserId: loginedUser.data.id, openState: openState, switchType: switchType }).then(res => {
            if (res.code === 200) {
                if (res.data.state == 2) {
                    message.error(res.data.reason, 6);
                }
                this.fetchThirdAuth();
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    handleMsgTemplateCheck = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                const { loginedUser } = this.props;
                findMsgTemplateCheck(Object.assign({ hostUserId: loginedUser.data.id }, values)).then(res => {
                    if (res.code === 200) {
                        if (res.data.state == 1) {
                            message.success('模板已设置');
                            this.fetchThirdAuth();
                        } else {
                            message.error(res.data.reason, 6);
                        }
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                })
            } else {

            }
        });
    }



    render() {
        const { visible, formLoading, authData } = this.state
        const { getFieldDecorator } = this.props.form;
        const { loginedUser } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 5 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 17 },
                sm: { span: 17 },
            },
        };



        return (
            <ASBody>
                <Spin spinning={formLoading}>
                    {authData &&
                        <div style={{ background: '#fff', paddingBottom: 100 }}>
                            {
                                authData.authState == 2 &&
                                <div style={{ textAlign: 'center', paddingTop: 114 }}>
                                    <Button type="primary" onClick={() => {
                                        window.open(authData.authUrl)
                                    }}>
                                        前往微信授权
                                   </Button>
                                    <p style={{ marginTop: 8, color: '#959595' }}>授权您的微信公众号后，参与人扫码报名或签到时，可以弹出您的公众号(替换签到家公众号），并且可以在公众号上推送报名和签到成功信息。</p>
                                    <p style={{ marginTop: 8, color: '#959595' }}>要求：一、您的公众号是已经认证过的服务号；二、您的微信是该公众号的管理员；三、需要高级会员<a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/2257078" target="_Blank"> 详细帮助</a></p>

                                </div>
                            }
                            {/* {
                                authData.state == 2 &&
                                <div style={{ textAlign: 'center', paddingTop: 114 }}>
                                    <p style={{ marginTop: 8, color: '#959595' }}>未设置消息模板。</p>
                                </div>
                            } */}
                            {
                                authData.authState == 1 &&
                                <Collapse
                                    bordered={false} defaultActiveKey={['1']} >
                                    <Collapse.Panel header="授权和消息推送 开关" key="1">
                                        <div style={{ margin: '20px 0' }}>
                                            <div>
                                                <span>
                                                    开启微信授权：<Switch
                                                        checked={this.state.loginSwitch}
                                                        onChange={e => {
                                                            if (this.state.validity) {
                                                                this.setState({ loginSwitch: e });
                                                                this.handleSwitchOpert(e ? 1 : 2, 1)
                                                            } else {
                                                                this.pstView.show()
                                                            }

                                                        }}
                                                        checkedChildren="开启"
                                                        unCheckedChildren="关闭" />
                                                    {/* {authData.state == 3 && <p style={{color:'#959595'}}>{authData.reason}</p>}           */}
                                                </span>
                                            </div>
                                            {authData.msgTempletStatus == 1 && authData.loginAuthSwitchState == 1 &&
                                                <div style={{ marginTop: 20 }}>
                                                    开启报名和签到推送：<Switch
                                                        checked={this.state.msgSwitch}
                                                        onChange={e => {
                                                            this.setState({ msgSwitch: e });
                                                            this.handleSwitchOpert(e ? 1 : 2, 2)
                                                        }}
                                                        checkedChildren="开启"
                                                        unCheckedChildren="关闭" />
                                                    {/* {authData.state == 3 && <p style={{color:'#959595'}}>{authData.reason}</p>}           */}
                                                </div>}
                                            {
                                                authData.msgSwitchState == 1 && authData.loginAuthSwitchState == 1 &&
                                                <div style={{ marginTop: 40, display: 'flex', alignItems: 'center' }}>
                                                    <QRCode
                                                        value={`${mobile_url_domin}/mobile/testmsgsend?hostUserId=${loginedUser.data.id}`}
                                                        size={100}
                                                        refName="test-qr-canvas"
                                                        logoWidth={23}
                                                        logoHeight={23}
                                                    />
                                                    <span style={{ marginLeft: 15, color: '#959595' }}>（微信扫码，消息推送测试）</span>
                                                </div>
                                            }

                                        </div>
                                    </Collapse.Panel>
                                </Collapse>
                            }
                            {
                                authData.authState == 1 &&
                                <Collapse
                                    bordered={false} defaultActiveKey={['1']} >
                                    <Collapse.Panel header={
                                        <div>消息模板配置 <span style={{ color: '#959595' }}>（需先设置消息模板ID，才能开启消息推送；ID来自您公众号上的配置<a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/2257078" target="_Blank"> 详细帮助</a>）</span></div>
                                    } key="1">

                                        <Form.Item
                                            {...formItemLayout}
                                            label="报名成功消息模板ID"
                                            extra={authData.attendedTemplateContent}
                                        >
                                            {getFieldDecorator('attendedTemplateId', {
                                                initialValue: authData.attendedTemplateId,
                                            })(
                                                <Input />
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            {...formItemLayout}
                                            label="签到成功消息模板ID"
                                            extra={authData.checkinTemplateContent}
                                        >
                                            {getFieldDecorator('checkinTemplateId', {
                                                initialValue: authData.checkinTemplateId,
                                            })(
                                                <Input />
                                            )}
                                        </Form.Item>
                                        <div style={{ textAlign: 'center' }}>
                                            <Button type="dashed" style={{ width: 150 }}
                                                onClick={this.handleMsgTemplateCheck}
                                            >保存消息模板</Button>
                                        </div>
                                    </Collapse.Panel>
                                </Collapse>
                            }
                        </div>}
                </Spin>



                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}

                />


            </ASBody>

        )
    }
}





export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(WxAuthorization));



// WEBPACK FOOTER //
// ./src/containers/usersfrom/WxAuthorization.jsx